// NPM Imports
import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../revvComponents";

// Components Imports
import MetaFieldViewHeader from "./MetaFieldViewHeader";
import MetaFieldCategories from "./MetaFieldCategories";
// import MetaFielItems from "./MetaFieldItems";
import DocumentDetails from "../DocumentDetails";
import TemplateDetailsGlobal from "../TemplateDetailsGlobal";
import MetaFieldBox from "./MetaFieldBox";

// Actions Imports

// Internal Imports

// Destructuring

// Declarations

export default function MetaFieldView({
  currentView,
  metaFieldsCount,
  mode,
  metaGroups,
  templatedIdInDoc,
}) {
  const [showCreateMetaBox, handleCreateMetaFieldBox] = useState(false);
  return (
    <div className="metafieldview-main-container">
      {currentView === "custom_mf" && (
        <MetaFieldViewHeader
          mode={mode}
          metaFieldsCount={metaFieldsCount}
          handleCreateMetaFieldBox={handleCreateMetaFieldBox}
        />
      )}
      {/* ------ meta field create meta field section ------ */}
      {showCreateMetaBox && (
        <MetaFieldBox
          mode={mode}
          handleCreateMetaFieldBox={handleCreateMetaFieldBox}
        />
      )}
      {/* ------ meta field categories section ------ */}
      {currentView === "custom_mf" && (
        <div className="metafieldview-categories-wrapper">
          <MetaFieldCategories
            mode={mode}
            templatedIdInDoc={templatedIdInDoc}
            metaGroups={metaGroups}
          />
        </div>
      )}
      {currentView === "global_mf" && mode === "DOCUMENT" && (
        <div className="globalmetafieldview-wrapper">
          <DocumentDetails />
        </div>
      )}
      {currentView === "global_mf" && mode === "TEMPLATE" && (
        <div className="globalmetafieldview-wrapper">
          <TemplateDetailsGlobal />
        </div>
      )}
      {/* <MetaFielItems /> */}
    </div>
  );
}
